import { Model } from '@/models/Model';
export class OpeningHour extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'OpeningHour';
        this.$endpoint = '/opening-hours';
        this.$fillable = ['starts_at', 'ends_at'];
    }
    getFilterLabel() {
        return this.id || '';
    }
}
